<template>
    <div class="mt-2 pb-3 relative">
        <p class="is-size-7 p-1 has-text-weight-medium">
            {{ displayName }}
        </p>
        <!-- <UserInfo v-if="isLogged" :userIdentification="userIdentification" /> -->
        <UserCau v-if="isLogged" :roomId="roomId"></UserCau>
        <div class="right-corner is-pointer" @click="openBigParticipant">
            <Icon
                family="fa"
                name="fa-expand-arrows-alt"
                helperClass="medium-icon"
            />
        </div>
        <div
            v-if="hasVideoOrAudio"
            ref="videoContainer"
            class="boxCamera is-radiusless"
        ></div>
        <VideoPlaceholder v-if="!hasVideo" :name="userName" :small="true" />
        <BigParticipant
            v-if="showBigParticipant"
            :stream="stream"
            :userName="userName"
            @close="closeBigParticipant"
        />
    </div>
</template>

<script>
import VideoPlaceholder from "./VideoPlaceholder";
import BigParticipant from "./BigParticipant";
//import UserInfo from "./user-info/UserInfo";
import UserCau from "./user-info/UserCau";
import { mapGetters } from "vuex";

export default {
    name: "participant",
    components: {
        VideoPlaceholder,
        BigParticipant,
        //UserInfo,
        UserCau,
    },
    props: {
        participant: {
            type: Object,
            required: true,
        },
        userName: {
            type: String,
            default: "",
        },
        userIdentification: {
            type: String,
            default: "",
        },
        roomId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            showBigParticipant: false,
            stream: null,

            mutedAudio: false,
            mutedVideo: false,
        };
    },
    mounted() {
        window.console.log(this.participant);
        this.initialiceCamera(this.participant);
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcIsAuthenticated"]),
        isLogged() {
            return this.oidcIsAuthenticated;
        },
        hasAudio() {
            return this.participant.audioTracks.size > 0 && !this.mutedAudio;
        },
        hasVideo() {
            return this.participant.videoTracks.size > 0 && !this.mutedVideo;
        },
        hasVideoOrAudio() {
            return this.hasVideo || this.hasAudio;
        },
        haveUserIdentification() {
            return this.userIdentification !== "";
        },
        displayName() {
            let name = this.userName;
            if (this.userIdentification !== "") {
                name += ` (${this.userIdentification})`;
            }
            return name;
        },
    },
    methods: {
        initialiceCamera(participant) {
            const div = document.createElement("div");
            div.id = participant.sid;
            participant.on("trackSubscribed", (track) => {
                this.trackSuscribed(div, track);

                let isAudio = track.kind === "audio";
                let isVideo = track.kind === "video";

                if (isAudio) {
                    track.on("disabled", () => {
                        this.mutedAudio = true;
                    });

                    track.on("enabled", () => {
                        this.mutedAudio = false;
                    });
                } else if (isVideo) {
                    track.on("disabled", () => {
                        this.mutedVideo = true;
                    });

                    track.on("enabled", () => {
                        this.mutedVideo = false;
                    });
                }
            });
            participant.on("trackUnsubscribed", this.trackUnsubscribed);
            participant.tracks.forEach((publication) => {
                if (publication.isSuscribed) {
                    this.trackSuscribed(div, publication.track);
                }
            });

            this.$refs.videoContainer.appendChild(div);
        },
        trackSuscribed(container, track) {
            container.appendChild(track.attach());
        },

        trackUnsubscribed(track) {
            track.detach().forEach((element) => element.remove());
        },
        openBigParticipant() {
            if (this.stream === null) {
                let video = this.$refs.videoContainer.querySelector("video");
                this.stream = video.captureStream();
            }
            this.showBigParticipant = true;
        },
        closeBigParticipant() {
            this.showBigParticipant = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.video-title {
    padding: 0.5rem;
}

.boxCamera {
    width: 225px;
}
</style>